export default class BlogService {

    constructor(resource, slug) {
        if(slug) {
            this._resource = resource('blog/'+slug);
        } else {
            this._resource = resource('blog/');
        }
    }

    Blog() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/BlogService.js